import {ApckPortletTable} from "../portlet";
import {ScanObject} from "../../scans/scan_table";

export const ApckPortletRecentScans = /*#__PURE__*/ ApckPortletTable.extend({
    props: {
        ctype: {
            type: String,
            default: "recentscansportlet"
        },
        title: {
            type: String,
            default: "Recent Scans"
        },
        size: {
            type: String,
            default: "lg"
        },
        description: {
            type: String,
            default: "A quick access table of recent scans"
        },
        src: {
            type: String,
            default: "/recentscans"
        },
        limit: {
            type: Number,
            default: 5
        },
        sglRowAction: {
            type: Function,
            default: function (rec) {
                if (this.$globalFlags.spa) {
                    var res = {
                        name: 'scans.results',
                        params: {
                            scan_id: rec.get("_id")
                        }
                    };
                    if (rec.latest_result_set) {
                        res = {
                            name: 'scans.results.instance',
                            params: {
                                scan_id: rec.get("_id"),
                                result_id: rec.latest_result_set
                            }
                        };
                    }
                    return this.$router.push(res);
                } else {
                    if (rec.latest_result_set) {
                        window.open(`/scans/${rec.get('_id')}/instances/${rec.latest_result_set}`, '_blank').focus();
                    } else {
                        window.open(`/scans/${rec.get('_id')}`, '_blank').focus();
                    }
                }
            },
        },
        cols: {
            type: Array,
            default: () => [
                {heading: "Name", data: "description", canSearch: true},
                {
                    heading: "Found",
                    ctype: "vulncolumn",
                    data: "vuln_counts",
                    canSearch: false,
                    width: 190,
                    center: true
                },
            ]
        },
    },
    methods: {
        scan_rescan: function (row) {
            const cmp = this;
            var scan = new ScanObject(row.data);
            scan.rescanScan().done(function () {
                cmp.store.load(cmp.store.lastParams);
            });
        },
        scan_delete: function (row) {
            const cmp = this;
            var scan = new ScanObject(row.data);
            scan.delete(function () {
                cmp.store.load(cmp.store.lastParams);
            });
        },
        scan_settings: function (row) {
            if (row.get('latest_result_set')) {
                this.$router.push({
                    name: 'scans.results.instance',
                    params: {
                        scan_id: row.get('_id'),
                        result_id: row.get('latest_result_set')
                    },
                    query: {
                        tab: 'Settings'
                    }
                });
            } else {
                this.$router.push({
                    name: 'scans.results',
                    params: {
                        scan_id: row.get('_id')
                    },
                    query: {
                        tab: 'Settings'
                    }
                });
            }
        }
    },
    data: function () {
        return {
            table_actions: [
                {
                    title: "Rescan",
                    icon: "fa-refresh",
                    class: "btn-primary",
                    handler: this.scan_rescan,
                    conditions: function (row) {
                        var status = row.get('raw_status');
                        return (status != "RUNNING" && status != "NONE");
                    }
                }, {
                    title: "Edit Settings",
                    icon: "fa-pencil",
                    class: "btn-secondary",
                    handler: this.scan_settings
                }, {
                    title: "Delete Scan",
                    icon: "fa-trash",
                    class: "btn-negative",
                    handler: this.scan_delete
                }
            ],
            options: {
                user_filter: {
                    label: "Scan assignment",
                    type: "select",
                    default: "all",
                    choices: [{
                        label: "All scans",
                        value: "all"
                    }, {
                        label: "My scans",
                        value: "user"
                    }]
                },
                order: {
                    label: "Order",
                    type: "select",
                    default: "default",
                    choices: [{
                        label: "Latest Definition",
                        value: "default"
                    }, {
                        label: "Latest Result",
                        value: "latest_result"
                    }]
                }
            }
        };
    }
});
